module.exports = __webpack_public_path__ + "static/image3-86b85d6ad59972eea59aeb5c989eb683.png";